<template>
  <div>
    <header-top></header-top>
    <div class="hotList">
      <div class="bagImgBox" :style="bgImg | bgImageUrl">
        <div class="bgBox">
          <div class="infoBox">
            <img
              class="leftImg"
              src="/static/home/img_list_left@2x.png"
              alt=""
            />
            <div class="listInfo">
              <p class="listText">{{ $t("live.MANA榜单") }}</p>
              <p class="listTime">{{ $t("live.每天上午10:00点前更新") }}</p>
            </div>
            <img
              class="rightImg"
              src="/static/home/img_list_right@2x.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="videoBox">
        <div class="navBox">
          <span
            class="nav"
            :class="{ active: type == 1 }"
            @click="changeType(1)"
            >{{ $t("live.周榜") }}</span
          >
          <span
            class="nav"
            :class="{ active: type == 2 }"
            @click="changeType(2)"
            >{{ $t("live.月榜") }}</span
          >
          <span
            class="nav"
            :class="{ active: type == 3 }"
            @click="changeType(3)"
            >{{ $t("live.总榜") }}</span
          >
        </div>
        <div class="videoList clearfix">
          <div class="listBox" v-for="(item, i) in videoList" :key="i">
            <item
              :id="item.videoId"
              :title="item.title"
              :thumb="item.thumb | imageUrl('/static/moren.png', 510, 288)"
              :nickName="item.userNickName"
              :avatar="item.userAvatar"
              :cat="item.industryTitle || item.professionTitle"
              :isRecommend="item.isRecommend"
              :userId="item.userId"
              :duration="item.duration"
              :tags="item.categoryTagGroupInfoList"
              :count="item.viewCount"
              :index="i"
              :pageIndex="pageIndex"
            ></item>
          </div>
        </div>
        <pagination
          v-if="totalPage > 1 && type !== 2"
          :totalRecord="totalRecord"
          :pageSize="pageSize"
          :pageIndex="pageIndex"
          @OnCurrentChanged="changePage"
        />
      </div>
    </div>
    <footer-down class="searchFooter"></footer-down>
  </div>
</template>

<script>
import HeaderTop from "@/components/v2/Header.vue";
import FooterDown from "@/components/v2/Footer.vue";
import Pagination from "@/components/v2/Pagination";
import item from "@/pages/hotList/item";
export default {
  name: "hotList",
  metaInfo() {
    return {
      title: this.$t("live.榜单") + " | MANA",
    };
  },
  components: {
    HeaderTop,
    FooterDown,
    item,
    Pagination,
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 20,
      type: 1,
      videoList: [],
      totalRecord: 0,
      totalPage: null,
      bgImg: null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let step = this.$route.params.step.toLocaleLowerCase();
      this.type = step === "weeklist" ? 1 : step === "monthlist" ? 2 : 3;
      if (this.type == 1) {
        this.buriedPoint(51,0)
        this.pageSize = 20;
      }
      if (this.type == 2) {
        this.buriedPoint(52,0)
        this.pageSize = 30;
      }
      if (this.type == 3) {
        this.buriedPoint(53,0)
        this.pageSize = 20;
      }
      this.pageIndex = 1;
      this.videoList = [];
      this.bgImg = null;
      this.getVideoList();
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getVideoList();
      this.goToTop();
    },
    changeType(type) {
      let step = type == 1 ? "weeklist" : type == 2 ? "monthlist" : "alllist";
      this.$router.push("/hotList/" + step);
    },
    getVideoList() {
      let params = {
        type: this.type,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      this.$http.get("/api/stat/getRankingList", { params }).then((res) => {
        if (res.code === "OK") {
          this.videoList = res.data.list;
          if (this.videoList.length && this.pageIndex == 1) {
            this.bgImg = this.videoList[0].thumb;
          }
          this.totalRecord =
            res.data.totalRecord > 200 ? 200 : res.data.totalRecord;
          this.totalPage = res.data.totalPage;
        }
      });
    },
    goToTop() {
      timer = requestAnimationFrame(function fn() {
        var oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 200;
          timer = requestAnimationFrame(fn);
        } else {
          this.goToTop(timer);
        }
      });
    },
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  watch: {
    $route(to, from) {
      this.init();
    },
  },
};
</script>

<style lang="stylus" scoped>
.hotList {
  min-width: 1110px;

  .bagImgBox {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% auto;

    .bgBox {
      height: 180px;
      background: linear-gradient(180deg, rgba(54, 100, 237, 0.7) 0%, rgba(32, 38, 204, 0.95) 100%);

      .infoBox {
        width: 1110px;
        margin: 0 auto;
        text-align: center;
        padding-top: 40px;

        .leftImg {
          width: 44px;
          height: 100px;
        }

        .rightImg {
          width: 44px;
          height: 100px;
        }

        .listInfo {
          display: inline-block;
          vertical-align: middle;
          margin: 0 20px;

          .listText {
            height: 32px;
            font-size: 28px;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 32px;
            margin-bottom: 10px;
          }

          .listTime {
            height: 18px;
            font-size: 12px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 18px;
          }
        }
      }
    }
  }

  .videoBox {
    width: 1110px;
    margin: 0 auto;
    padding-bottom: 50px;

    .navBox {
      width: 100%;
      text-align: center;
      margin-bottom: 40px;

      .nav {
        font-size: 17px;
        font-weight: 400;
        color: #999999;
        display: inline-block;
        vertical-align: middle;
        height: 56px;
        line-height: 56px;
        box-sizing: border-box;
        margin-right: 68px;
        cursor: pointer;

        &:nth-child(3) {
          margin-right: 0;
        }
      }

      .active {
        border-bottom: 3px solid rgba(10, 10, 10, 1);
        color: #0A0A0A;
        font-weight: 600;
      }
    }

    .videoList {
      .listBox {
        width: 255px;
        height: 248px;
        float: left;
        margin-right: 30px;
        margin-bottom: 30px;

        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hotList/hotList.vue